/**
 * DEMO — de testaccounts van het beheer. Met een backend logt iedereen in via
 * POST /admin/login en bestaat dit bestand niet meer.
 */
export const DEMO_ADMIN = {
  email: 'sarah@beautybewust.nl',
  password: 'bewust',
  name: 'Sarah',
} as const

/**
 * De voorbeeldcollega (data/staff.ts, "Mila"): om te zien wat een collega in het beheer ziet.
 * Alleen haar eigen afspraken, afronden en afrekenen; geen omzet, klantenlijst of instellingen.
 */
export const DEMO_COLLEAGUE = {
  email: 'mila@beautybewust.nl',
  password: 'bewust',
  name: 'Mila',
  staffId: 'mila',
} as const

/**
 * Iemand die de marketing doet (rol Marketing): geen behandelaar, dus geen persoon in het rooster
 * of op de website. Teksten, journal, social, ontwerpen, nieuwsbrief en Inzicht.
 */
export const DEMO_MARKETING = {
  email: 'noor@beautybewust.nl',
  password: 'bewust',
  name: 'Noor',
  staffId: 'noor',
} as const
